/**
 * Check if an element is visible in the viewport.
 * Used for video playback control based on visibility.
 */
const isElementVisible = (element: HTMLElement): boolean => {
  const rect = element.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;

  return (
    rect.top < viewportHeight &&
    rect.bottom > 0 &&
    rect.left < viewportWidth &&
    rect.right > 0 &&
    rect.height > 0
  );
};

export default isElementVisible;
